import OwnerType from "@/utils/constants/OwnerType.ts";
import PreferencesRequest from "@/utils/constants/PreferencesRequest.ts";
import MetaData from "@/utils/common/MetaData.ts";

export default class SearcherViewUtils
{
  static async fetchLayoutPreferences(entityType: string, listViewName?: string): Promise<namaTypes.UIPreferences> {
    let req: Record<any, any> = {
      owner: {
        ownerType: OwnerType.Entity,
        ownerId: entityType
      },
      properties: [PreferencesRequest.SEARCHER_LAYOUT, PreferencesRequest.VIEW_NAMES],
      searcherLayoutScreenName: listViewName
    };
    return await MetaData.fetchPreferences(req, (preferences: namaTypes.UIPreferences) => preferences);
  }


}
